//!nordy
// import { isCloud } from '@/platform/distribution/types'

export const CORE_MENU_COMMANDS = [
  [[], ['Comfy.NewBlankWorkflow']],
  [[], []], // Separator after New
  [['File'], ['Comfy.OpenWorkflow']],
  [
    ['File'],
    [
      'Comfy.SaveWorkflow',
      'Comfy.SaveWorkflowAs',
      'Comfy.ExportWorkflow',
      'Comfy.ExportWorkflowAPI'
    ]
  ],
  [['Edit'], ['Comfy.Undo', 'Comfy.Redo']],
  [
    ['Edit'],
    [
      'Comfy.Canvas.CopySelected',
      'Comfy.Canvas.PasteFromClipboard',
      'Comfy.Canvas.SelectAll'
    ]
  ],
  [['Edit'], ['Comfy.ClearWorkflow']],
  [['Edit'], ['Comfy.OpenClipspace']],
  [
    ['Edit'],
    [
      //!nordy - RefreshNodeDefinitions 비활성화 (nordy에서 미사용)
      // 'Comfy.RefreshNodeDefinitions'
      //!nordy - UnloadModels 비활성화 (다른 유저 서비스 영향 방지)
      // ...(isCloud
      //   ? []
      //   : [
      //       'Comfy.Memory.UnloadModels',
      //       'Comfy.Memory.UnloadModelsAndExecutionCache'
      //     ])
    ]
  ],
  [['View'], []]
  //!nordy - Help 메뉴 비활성화 (ComfyUI 공식 링크 대신 Nordy 지원 링크 사용)
  // [
  //   ['Help'],
  //   [
  //     'Comfy.Help.OpenComfyUIIssues',
  //     'Comfy.Help.OpenComfyUIDocs',
  //     'Comfy.Help.OpenComfyOrgDiscord',
  //     'Comfy.Help.OpenComfyUIForum'
  //   ]
  // ],
  // [['Help'], ['Comfy.Help.AboutComfyUI', 'Comfy.ContactSupport']]
]
